import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "23",
  height: "23",
  fill: "none",
  viewBox: "0 0 23 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#1B1F3B",
      d: "M18.375 12.875a1.36 1.36 0 0 1-.896 1.284l-4.432 1.638-1.633 4.436a1.369 1.369 0 0 1-2.568 0l-1.643-4.436-4.436-1.633a1.368 1.368 0 0 1 0-2.568l4.436-1.643 1.633-4.436a1.368 1.368 0 0 1 2.567 0l1.643 4.436 4.437 1.633a1.36 1.36 0 0 1 .892 1.289m-4.813-8.25h1.375V6a.687.687 0 1 0 1.375 0V4.625h1.375a.687.687 0 0 0 0-1.375h-1.375V1.875a.687.687 0 1 0-1.375 0V3.25h-1.375a.687.687 0 0 0 0 1.375m7.563 2.75h-.688v-.688a.687.687 0 1 0-1.375 0v.688h-.687a.687.687 0 0 0 0 1.375h.687v.687a.687.687 0 1 0 1.375 0V8.75h.688a.687.687 0 0 0 0-1.375"
    }, null, -1)
  ]))]))
}
export default { render: render }